import { useContext, useEffect, useRef } from 'react';
import { MeContext } from '../../../context/MeContext';
import { useTrackEventMutation } from '../../../store/redux/api/onboardingApi';
import { useOnboardingSurveyGate } from './useOnboardingSurveyGate';

const seenKey = (accountId: string) => `setup_reached_${accountId}`;

export const useTrackSetupReached = (): void => {
  const surveyPending = useOnboardingSurveyGate();
  const meCtx = useContext(MeContext) as {
    state: { account: { id?: string | number } | null };
  };
  const accountId =
    meCtx.state.account?.id != null
      ? String(meCtx.state.account.id)
      : undefined;
  const [trackEvent] = useTrackEventMutation();
  const firedRef = useRef(false);

  useEffect(() => {
    if (surveyPending || !accountId || firedRef.current) return;

    let alreadySeen = false;
    try {
      alreadySeen = localStorage.getItem(seenKey(accountId)) === '1';
    } catch {
      // localStorage can throw in private mode / quota errors; treat as unseen.
    }
    firedRef.current = true;
    if (alreadySeen) return;

    trackEvent({ event: 'setup-reached' })
      .unwrap()
      .then(() => {
        try {
          localStorage.setItem(seenKey(accountId), '1');
        } catch {
          // Soft-fail: LD conversion-metric dedup still guards double counting.
        }
      })
      .catch(() => {
        // Guardrail telemetry must never disrupt the app; allow a retry next mount.
        firedRef.current = false;
      });
  }, [surveyPending, accountId, trackEvent]);
};
